import { AggregationValue } from "./types";
import { TimezoneUtils } from "../../../utils/timezoneUtils";

export interface AggregationOption {
    value: AggregationValue;
    label: string;
    short: string;
}

export const DEFAULT_AGGREGATION_OPTIONS: AggregationOption[] = [
    { value: "day", label: "Daily", short: "D" },
    { value: "week", label: "Weekly", short: "W" },
    { value: "month", label: "Monthly", short: "M" },
    { value: "year", label: "Yearly", short: "Y" }
];

export const startOfDay = (date: Date): Date => {
    const next = new Date(date);
    next.setHours(0, 0, 0, 0);
    return next;
};

export const endOfDay = (date: Date): Date => {
    const next = new Date(date);
    next.setHours(23, 59, 59, 999);
    return next;
};

export const createDefaultDateRange = (daysBack: number = 7): [Date, Date] => {
    const end = endOfDay(new Date());
    const start = startOfDay(new Date(end));
    start.setDate(start.getDate() - daysBack);
    return [start, end];
};

export const formatDateRange = ([start, end]: [Date, Date]): string => {
    return TimezoneUtils.formatDateRange([start, end]);
};

export const ensureChronological = (start: Date, end: Date): [Date, Date] => {
    if (start.getTime() > end.getTime()) {
        return [startOfDay(end), endOfDay(start)];
    }
    return [startOfDay(start), endOfDay(end)];
};
